<!-- Simple modal for notification only. No action to be taken -->
<template>
   <modal>
      <div slot="header">
         <span v-if="error" class="red-header">Uh-oh</span>
      </div>

      <div slot="subhead">
         {{subheadText}}
      </div>

      <div slot="body">
         <div class="modal-input-explain">{{message}}
         </div>
      </div>

      <div slot="footer">
         <button v-if="actionType == 'login'" @click="handleLoginClick" class="btn-yellow">Login</button>

         <div v-else-if="actionType == 'input'">
            <div>
               <input class="modal-input" v-model="inputData">
            </div>
            <div>
               <button class="btn-yellow" @click="$emit('modalOk', inputData)">Save</button>
            </div>
         </div>

      </div>
   </modal>
</template>

<script>
import Modal from './Modal';

export default {

   data() {
      return {
         inputData: ''
      }
   },

   props: {
      error: {
         type: Boolean,
         required: false,
         default: false
      },
      title: {
         type: String,
         required: false
      },
      headerText: {
         type: String,
         required: false
      },
      subheadText: {
         type: String,
         required: false
      },
      message: {
         type: String,
         required: false
      },
      list: {
         type: Array,
         required: false
      },
      actionType: {
         type: String,
         required: true
      }
   },

   methods: {
      handleLoginClick() {
         window.location.href = "login.html";
      }
   },

   components: {
      Modal
   }
}
</script>